import type { ReactNode } from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function LegalPage({
  title,
  description,
  lastUpdated,
  children,
}: {
  title: string;
  description: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  useDocumentMeta(title, description);

  return (
    <section className="container py-10 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-foreground mb-6">{title}</h1>
      <p className="text-muted-foreground mb-6">Ultimo aggiornamento: {lastUpdated}</p>
      <div className="space-y-8 text-foreground/80">{children}</div>
    </section>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="space-y-3">
      <h2 className="text-2xl font-semibold text-foreground mb-4">{title}</h2>
      {children}
    </section>
  );
}

export function MailLink({ email }: { email: string }) {
  return (
    <a href={`mailto:${email}`} className="text-primary hover:underline">
      {email}
    </a>
  );
}
